'use client';

import { mergeClasses } from "@griffel/react";
import { useTableHeaderStyles_unstable } from "../TableHeader/useTableHeaderStyles.styles.js";
export const dataGridHeaderClassNames = {
  root: 'fui-DataGridHeader'
};
/**
 * Apply styling to the DataGridHeader slots based on the state
 */
export const useDataGridHeaderStyles_unstable = state => {
  useTableHeaderStyles_unstable(state);
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(dataGridHeaderClassNames.root, state.root.className);
  return state;
};